import { Input } from "@hawkins/components";
import React, { forwardRef } from "react";
import { useFormikInput } from "./useFormikInput";
const FormikInput = forwardRef(
  ({
    debounce,
    debounceDelay,
    inputRef,
    name,
    onBlur,
    onChange,
    isValueAllowed,
    ...rest
  }, ref) => {
    const [formikInputProps] = useFormikInput(name, {
      debounce,
      debounceDelay,
      inputRef,
      isValueAllowed,
      onBlur,
      onChange
    });
    return /* @__PURE__ */ React.createElement(Input, { ref, ...formikInputProps, ...rest });
  }
);
export {
  FormikInput
};
//# sourceMappingURL=FormikInput.js.map
